import React from 'react';
import { CommonPage } from '../reports-new';
import { CONST_REPORT_TABS_NEW_COLUMNS, } from '../../common/reportsConstants';
export default function OosAccountType() {
  const tabKey = 'OOS Account';
  const columnsProp = CONST_REPORT_TABS_NEW_COLUMNS.filter(item => item.key === tabKey)[0].summary.columns;
  const level = CONST_REPORT_TABS_NEW_COLUMNS.filter(item => item.key === tabKey)[0].summary.level;
  return (
    <div className="oos-account-oos-account-type">
      <CommonPage tabKey={tabKey} columnsProp={columnsProp} level={level} />
    </div>
  );
};

OosAccountType.propTypes = {};
OosAccountType.defaultProps = {};
